import { useFormContext } from "react-hook-form";

export const useOtpTemplateCode = () => {
  const { getValues } = useFormContext();
  // overwrite templateCode if pickedCrosses is not empty, different templateCode for product with cross
  return getValues("pickedCrosses")?.length > 0 ? getValues("templateCodeCross") : getValues("templateCode");
}
